import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WishlistService } from '../../../services/raintree/Transmission/wishlist.service';
import { SerialNoCellComponent } from '../../../table-cell/serial-no-cell.component';
import {
  UserWishlistResponse,
  WishlistResponse,
} from '../../../services/raintree/interfaces/wishlist.interface';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
import { ToastrService } from 'ngx-toastr';
import { FWTransferDialogComponent } from '../../../find-details/fw-transfer-dialog/fw-transfer-dialog.component';
import { DeleteCellComponent } from '../../../table-cell/delete-cell.component';
import { DpSuccessMessageComponent } from '../../../common-component/dp-success-message/dp-success-message.component';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { deleteRowData } from '../../../services/common/utils';
import { AppConfigService } from '../../../services/config/app-config.service';
import { Label, Permissions, PermissionsKey } from '../../../enum/permission';
import { CommonModule, DatePipe } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PrintAndMonitorService } from '../../../services/raintree/Transmission/print-and-monitor.service';
import { ActivatedRoute } from '@angular/router';
import { PrintService } from '../../../services/common/print.service';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import {
  MatAutocomplete,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MasterSearchTransmissionService } from '../../../services/raintree/Transmission/master-search.service';
import { ReportStatus } from '../../../services/raintree/interfaces/global-respo';
import { Subject } from 'rxjs/internal/Subject';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { RefreshedDateKey } from '../../../enum/refresh-date';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
import { ManageVisitCellComponent } from '../../../table-cell/manage-visit-cell-component';
import { PmWishlistFilterComponent } from './pm-wishlist-filter/pm-wishlist-filter.component';
import { VisitComponent } from '../../../print-monitor/visited/visit.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
@Component({
  selector: 'user-wishlist-dialog',
  standalone: true,
  templateUrl: './user-wishlist-dialog.component.html',
  styleUrl: './user-wishlist-dialog.component.scss',
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    DpTableComponent,
    CommonModule,
    InfiniteScrollModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatAutocomplete,
    MatTooltipModule,
    FormsModule,
    ClipboardModule, LoaderComponent
  ],
  providers: [DatePipe],
})
export class UserWishlistDialogComponent implements OnInit, OnDestroy {
  public isMobileDevice: boolean = false;
  pageNo: number = 1;
  private searchMemkey = new Subject<string>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _wishlistService: WishlistService,
    private dialog: MatDialog,
    private _dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    private _activatedRoute: ActivatedRoute,
    private toaster: ToastrService,
    private isMobile: CommonUtilService,
    private dialogRef: MatDialogRef<UserWishlistDialogComponent>,
    private _appConfig: AppConfigService,
    private _printAndMonitorService: PrintAndMonitorService,
    private printService: PrintService,
    private _masterSearchTransmissionService: MasterSearchTransmissionService,
    private datePipe: DatePipe
  ) { }
  userWishlists: any = [];
  userList: any[] = [];
  printAndMonitorUserWishlists: any = [];
  showPrintBtn: boolean = false;
  isLoading: boolean = false;
  permissionArray: any = [];
  isReload: boolean = false;
  printData: any = [];
  fieldWorkerName = new FormControl('');
  memKey: number | undefined;
  filterMemkey: any = [];
  appliedFilters = undefined;
  wishListUsers: any = [];
  filterUserWishlist: any = [];
  queryParamsObj: any = {};
  filteredRs: any[] = [];
  reportStatus: any = [];
  fiterStatus: any[] = [];
  status: any = [];
  lastRefreshedDate: any;
  displayColumnData: any = [
    {
      id: 'serialNo',
      name: 'Serial Number',
    },
    {
      id: 'fc',
      name: 'Family Code',
    },
    {
      id: 'mNm',
      name: 'Dikshyarthi Name',
    },
    {
      id: 'rNm',
      name: 'Ritwick Name',
    },
    {
      id: 'contact',
      name: 'Contact',
    },
    {
      id: 'addr',
      name: 'Address',
    },
    {
      id: 'livDate',
      name: 'Last Istavirty Date',
    },
  ];
  displayPrintAndMonitorColumnData: any = [
    {
      id: 'SL_NO',
      name: 'Serial No',
    },
    {
      id: 'dikshyarthi_name',
      name: 'Name',
    },
    {
      id: 'ritwiki_name',
      name: 'Ritwick Name',
    },
    {
      id: 'guardian_name',
      name: 'Guardian Name',
    },
    {
      id: 'initiation_date',
      name: 'Initiation Date'
    },
    {
      id: 'permanent_address',
      name: 'Address',
    },
    {
      id: 'visit',
      name: ''
    }
  ];
  cellComponentMap: any = {
    serialNo: SerialNoCellComponent,
  };
  cellComponentPrintAndMonitorMap: any = {
    SL_NO: SerialNoCellComponent,
    visit: ManageVisitCellComponent
  };
  queryParams: any;
  ngOnInit(): void {
    this.permissionArray = this._appConfig.fetchPermissionv3ByViewName();
    this.fetchPermissions();
    this.queryParams = { ...this._activatedRoute.snapshot.queryParams };
    this.isMobileDevice = this.isMobile.isMobileDevice();
    if (
      this.data.wishlist?.status != 'P' &&
      this.data.type == 'centralizedFd'
    ) {
      this.displayColumnData.push({
        id: 'actions',
        name: '',
      });
      this.cellComponentMap['actions'] = DeleteCellComponent;
    }
    if (this.data.type == 'centralizedReach') {
      this.fetchReacWishlistData();
    } else if (this.data?.favorites === 'like') this.fetchFavorites(false);
    else if (this.data.type == 'centralizedFd') this.fetchUserWishlist(true);
    else if (this.data.type == 'centralizedPm') this.fetchUserWishlistReport();
    this.fieldWorkerName.valueChanges.subscribe((item: any) => {
      if (item && item.length > 0) {
        this.filterUserWishlist = this.wishListUsers.filter((value: any) =>
          value.name.toLowerCase().includes(item.toLowerCase())
        );
      } else {
        this.filterUserWishlist = this.wishListUsers.filter(
          (value: any) => value.name
        );
        delete this.queryParamsObj.userId;
        this.fetchUserWishlistReport();
      }
    });
    this.searchMemkey.subscribe((value: string) => {
      const regex = /^[0-9]{8,}$/;
      if (value.length >= 8 && regex.test(value)) {
        value.trim();
        this.fetchUserWishlistReport();
      } else if (value.length === 0) {
        this.fetchUserWishlistReport();
      }
    });
    if (this.data.type === 'centralizedPm' && !this.data.favorites) {
      // this.fetchUsers();
    }
    if (this.data.favorites) {
      this.displayPrintAndMonitorColumnData.splice(1, 1);
      this.displayPrintAndMonitorColumnData.splice(1, 0, {
        id: 'dikshyatri_name',
        name: 'Name',
      });
      this.displayPrintAndMonitorColumnData.splice(5, 5);
      this.displayPrintAndMonitorColumnData.push({
        id: 'actions',
        name: '',
      });
      this.cellComponentPrintAndMonitorMap['actions'] = DeleteCellComponent;
    }
    this.fetchLastRefreshDate();
  }
  fetchLastRefreshDate() {
    let refreshDate: any = JSON.parse(decodeURIComponent(atob(localStorage.getItem('refresh-date')!)))
    if (refreshDate) {
      this.lastRefreshedDate = refreshDate.filter((item: any) =>
        item.configName.includes(RefreshedDateKey.wishlistItems)
      );
      this.lastRefreshedDate = this.datePipe.transform(
        this.lastRefreshedDate[0].date,
        'MMM d, y'
      );
    }
  }
  fetchPermissions() {
    let finalPerm: any = [];
    const countryPerm = this.permissionArray['INDIA'];
    if (this.data?.selectedState != '' && this.data?.selectedState) {
      finalPerm = countryPerm?.allStatesPerm;
      const statePerm = countryPerm?.statePerms[this.data?.selectedState];
      if (this.data?.selectedDistrict != '' && this.data?.selectedDistrict && statePerm?.districtPerms[this.data?.selectedDistrict]) {
        finalPerm = [...finalPerm, ...statePerm?.allDistrictsPerm, ...statePerm?.districtPerms[this.data?.selectedDistrict]];
      }
    }
    this.showPrintBtn = finalPerm.includes(Permissions.CanPrintDatum)
  }
  printPDF(isFav?: boolean) {
    if (isFav && this.data.type === 'centralizedPm') {
      this.fetchFavorites(true);
    }
    if (this.data.type === 'centralizedFd' && isFav) {
      this.fetchFavorites(true);
    }
    if (this.data.type === 'centralizedFd') {
      let paramsObj = {
        listType: 'PHL',
        printAll: true,
        uiState: this.data.selectedState,
        uiDistrict: this.data.selectedDistrict,
      };
      this._wishlistService
        .fetchUserWishlist(this.data.wishlist.id, paramsObj)
        .subscribe({
          next: (response: UserWishlistResponse) => {
            this.printData = response.data;
            const header: string = `FIND DETAILS | ${this.data.wishlist.name}`;
            const columns = [
              'SL NO',
              'FC',
              'DIKSHYARTHI NAME',
              'RITWICK NAME',
              'CONTACT',
              'LAST ISTAVIRTY DATE',
              'ADDRESS',
            ];
            const cellStyles: any = {
              0: { cellWidth: 2.5, halign: 'center' },
              1: { cellWidth: 3.5, halign: 'center' },
              2: { cellWidth: 5.0 },
              3: { cellWidth: 5.0 },
              4: { cellWidth: 2.5, halign: 'center' },
              5: { cellWidth: 2.5, halign: 'center' },
              6: { cellWidth: 8.0 },
            };
            const rows = this.printData.map((user: any) => [
              user?.serialNo,
              user.fc,
              user.mNm,
              user?.rNm,
              user.contact,
              user.livDate,
              user.addr,
            ]);
            const currentDate = new Date().toISOString().split('T')[0];
            const fileName = `${this.data.wishlist.name}_${currentDate}`;
            this.printService.printPdf(
              rows,
              columns,
              header,
              fileName,
              'l',
              'a4',
              true,
              cellStyles
            );
          },
          error: (error) => this.toaster.error(error),
        });
    } else if (this.data.type === 'centralizedPm') {
      let paramsObj = {
        uiState: this.data.selectedState,
        uiDistrict: this.data.selectedDistrict,
        printAll: true,
        pageLimit: 5000,
        wishlistId: this.data.wishlist.id,
        pageNo: this.pageNo,
      };
      this._wishlistService.fetchUserWishlistDetails(paramsObj).subscribe({
        next: (response: WishlistResponse) => {
          this.printData = response.data;
          const header = `PRINT & MONITOR | ${this.data.wishlist.name}`;
          const columns = [
            'SL NO',
            'DIKSHYARTHI NAME',
            'RITWICK NAME',
            'GUARDIAN NAME',
            'ADDRESS',
          ];
          const rows = this.printData.map((user: any) => [
            user?.SL_NO,
            user.dikshyarthi_name,
            user?.ritwiki_name,
            user.guardian_name,
            user.permanent_address,
          ]);
          const cellStyles: any = {
            0: { cellWidth: 2.5, halign: 'center' },
            1: { cellWidth: 5.5 },
            2: { cellWidth: 5.5 },
            3: { cellWidth: 5.5 },
            4: { cellWidth: 10.0 },
          };
          const currentDate = new Date().toISOString().split('T')[0];
          const fileName = `${this.data.wishlist.name}_${currentDate}`;
          this.printService.printPdf(
            rows,
            columns,
            header,
            fileName,
            'l',
            'a4',
            true,
            cellStyles
          );
        },
        error: (error) => this.toaster.error(error),
      });
    }
  }
  fetchReacWishlistData() {
    this._wishlistService
      .fetchReachUserWishlist(this.data.wishlist.id)
      .subscribe({
        next: (response: any) => { },
        error: (error) => this.toaster.error(error),
      });
  }
  fetchUserWishlist(isStart?: boolean) {
    if (isStart) {
      this.userWishlists = [];
      this.pageNo = 1;
    } else {
      this.pageNo += 1;
    }
    let paramsObj = {
      listType: 'PHL',
      pageNo: this.pageNo,
      pageSize: 25,
      uiState: this.data.selectedState,
      uiDistrict: this.data.selectedDistrict,
      requested: false,
    };
    if (this.data.transferRequest) {
      paramsObj['requested'] = true;
    }
    this._wishlistService
      .fetchUserWishlist(this.data.wishlist.id, paramsObj)
      .subscribe({
        next: (response: UserWishlistResponse) => {
          this.userWishlists = [...this.userWishlists, ...response.data];
        },
        error: (error) => this.toaster.error(error),
      });
  }
  fetchUsers() {
    let queryParams = { ...this._activatedRoute.snapshot.queryParams };
    let queryParamsObj = {};
    queryParamsObj = {
      uiState: queryParams['state'],
      uiDistrict: queryParams['district'],
      wishlistId: this.data.wishlist.id,
    };
    if (!this.wishListUsers.length) {
      this.isLoading = true;
      this._wishlistService.fetchWishListUsersName(queryParamsObj).subscribe({
        next: (response) => {
          this.wishListUsers =
            response.data.length > 0
              ? response.data.map((item: any) => {
                return {
                  userId: item.userId,
                  name: item.name,
                  email: item.email,
                };
                // item.name
              })
              : [];
          this.filterUserWishlist = this.wishListUsers;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.toaster.error(error);
        },
      });
    }
  }
  onScroll() {
    if (this.data.type === 'centralizedPm') this.fetchUserWishlistReport();
    else this.fetchUserWishlist(false);
  }
  onMemkeySearch(value: string) {
    this.searchMemkey.next(value);
  }
  onSelectionUser(item: any) {
    this.queryParamsObj.userId = item.userId;
    this.fetchUserWishlistReport();
  }
  openFilterDialog() {
    let dialogRef = this.dialog.open(PmWishlistFilterComponent, {
      // height: (this._mobileScreen.isMobileDevice())?'fit-content':'60vh',
      width: (this.isMobile.isMobileDevice()) ? '90vw' : '30vw'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.appliedFilters = result;
        this.fetchUserWishlistReport();
      }
    });
  }
  fetchUserWishlistReport() {
    const queryParams: any = { ...this._activatedRoute.snapshot.queryParams };
    this.pageNo = 1;
    this.queryParamsObj = {
      uiState: queryParams['state'],
      uiDistrict: queryParams['district'],
      wishlistId: this.data.wishlist.id,
      pageNo: this.pageNo,
      userId: this.queryParamsObj.userId || '',
      memKeyFilter: this.memKey || '',
    };
    Object.assign(this.queryParamsObj, this.appliedFilters);
    const cleanedObj = Object.fromEntries(
      Object.entries(this.queryParamsObj).filter(
        ([key, value]) => value !== null && value !== '' && value !== undefined && value !== -1
      )
    );
    this.isLoading = true;
    this._wishlistService.fetchUserWishlistDetails(cleanedObj).subscribe({
      next: (response) => {
        this.printAndMonitorUserWishlists = [...response.data];
        this.printAndMonitorUserWishlists =
          this.printAndMonitorUserWishlists.map((item: any) => {
            if (
              item.wishlistItemAddedBy === this.data.logUserid ||
              this.data.perm ||
              this.data?.logUserid == this.data?.wishlist?.userID
            )
              return {
                ...item,
                canDelete: true,
              };
            else
              return {
                ...item,
                canDelete: false,
              };
          });
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.toaster.error(error);
      },
    });
  }
  printPMFavourites() {
    this._printAndMonitorService
      .getFavorites({
        uiState: this.queryParams['state'],
        uiDistrict: this.queryParams['district'],
        printAll: true,
      })
      .subscribe({
        next: (response: any) => {
          this.printData = response.data;
          const header = 'PRINT & MONITOR FAVOURITES';
          const columns = [
            'SL NO',
            'DIKSHYARTHI NAME',
            'RITWICK NAME',
            'GUARDIAN NAME',
            'ADDRESS',
          ];
          const rows = this.printData.map((user: any) => [
            user?.SL_NO,
            user.dikshyatri_name,
            user?.ritwiki_name,
            user.guardian_name,
            user.permanent_address,
          ]);
          const cellStyles: any = {
            0: { cellWidth: 2.5, halign: 'center' },
            1: { cellWidth: 5.5 },
            2: { cellWidth: 5.5 },
            3: { cellWidth: 5.5 },
            4: { cellWidth: 10.0 },
          };
          const currentDate = new Date().toISOString().split('T')[0];
          const fileName = `PRINT-MONITOR-FAVOURITES_${currentDate}`;
          this.printService.printPdf(
            rows,
            columns,
            header,
            fileName,
            'l',
            'a4',
            true,
            cellStyles
          );
        },
        error: (error: string | undefined) => this.toaster.error(error),
      });
  }
  printFDFavourites() {
    this._wishlistService
      .fetchFavorites({
        uiState: this.data.selectedState,
        uiDistrict: this.data.selectedDistrict,
        printAll: true,
      })
      .subscribe({
        next: (response: UserWishlistResponse) => {
          this.printData = response.data;
          const header: string = 'FIND DETAILS FAVOURITES';
          const columns = [
            'SL NO',
            'FC',
            'DIKSHYARTHI NAME',
            'RITWICK NAME',
            'CONTACT',
            'LAST ISTAVIRTY DATE',
            'ADDRESS',
          ];
          const cellStyles: any = {
            0: { cellWidth: 2.5, halign: 'center' },
            1: { cellWidth: 3.5, halign: 'center' },
            2: { cellWidth: 5.0 },
            3: { cellWidth: 5.0 },
            4: { cellWidth: 2.5, halign: 'center' },
            5: { cellWidth: 2.5, halign: 'center' },
            6: { cellWidth: 8.0 },
          };
          const rows = this.printData.map((user: any) => [
            user?.serialNo,
            user.fc,
            user.mNm,
            user?.rNm,
            user.contact,
            user.livDate,
            user.addr,
          ]);
          const currentDate = new Date().toISOString().split('T')[0];
          const fileName = `FIND-DETAILS-FAVOURITES_${currentDate}`;
          this.printService.printPdf(
            rows,
            columns,
            header,
            fileName,
            'l',
            'a4',
            true,
            cellStyles
          );
        },
        error: (error) => this.toaster.error(error),
      });
  }
  fetchFavorites(type: boolean) {
    if (this.data.type === 'centralizedPm') {
      if (type) {
        this.printPMFavourites();
      } else {
        this._printAndMonitorService
          .getFavorites({
            uiState: this.queryParams['state'],
            uiDistrict: this.queryParams['district'],
          })
          .subscribe({
            next: (response: any) => {
              this.printAndMonitorUserWishlists = response.data;
            },
            error: (error: string | undefined) => this.toaster.error(error),
          });
      }
    } else {
      if (type) {
        this.printFDFavourites();
      } else {
        this._wishlistService
          .fetchFavorites({
            uiState: this.data.selectedState,
            uiDistrict: this.data.selectedDistrict,
          })
          .subscribe({
            next: (response: any) => {
              this.userWishlists = response.data;
            },
            error: (error) => this.toaster.error(error),
          });
      }
    }
  }
  openTransferWishlistDialog() {
    const dialogRef = this._dialog.open(FWTransferDialogComponent, {
      data: {
        id: this.data.wishlist.id,
        selectedState: this.data.selectedState,
        selectedDistrict: this.data.selectedDistrict,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.dialogRef.close(true);
        this.fetchUserWishlist(true);
      }
    });
  }
  onCellClick(event: any) {
    if (this.data?.favorites === 'like' && this.data.type === 'centralizedFd') {
      this._wishlistService.deleteFavoritesUserWishlist(event.id).subscribe({
        next: (response: any) => {
          this.dialog.open(DpSuccessMessageComponent, {
            panelClass: 'common-pannel-dialog-container',
            data: {
              mainHeading: 'Data had been deleted successfully',
              buttonValue: 'Done',
            },
          });
          deleteRowData(this.userWishlists, 'id', event.id);
          this.isReload = true;
        },
        error: (error) => {
          this.toaster.error(error);
        },
      });
    }
    else if (this.data.type === 'centralizedPm') {
      this.isLoading = true
      if (this.data?.favorites === 'like') {
        this._printAndMonitorService
          .deleteItemFavorites(event.SL_NO)
          .subscribe({
            next: (response: any) => {
              this.dialog.open(DpSuccessMessageComponent, {
                panelClass: 'common-pannel-dialog-container',
                data: {
                  mainHeading: 'Data had been deleted successfully',
                  buttonValue: 'Done',
                },
              });
              this.isLoading = false
              this.dialogRef.close();
            },
            error: (error: string | undefined) => {
              this.dialogRef.close();
              this.isLoading = false
              this.toaster.error(error);
            },
          });
      }
      else {
        if (event.type) {
          if (this.isMobile.isMobileDevice()) {
            const sheetRef = this.bottomSheet.open(VisitComponent, {
              data: {
                memKey: event.rowData,
                data: '',
                type: event.type
              },
            });
            this.isLoading = false;
            sheetRef.afterDismissed().subscribe((result) => {
              if (result === 'refresh table')
                this.fetchUserWishlistReport();
            });
          }
          else {
            const dialogRef = this.dialog.open(VisitComponent, {
              data: {
                memKey: event.rowData,
                data: '',
                type: event.type,
              },
              disableClose: true,
              width: (event.rowData.visit_count < 3) ? '720px' : '1300px', maxWidth: '1300px',
              height: '82vh', maxHeight: '90vh',
            });
            this.isLoading = false;
            dialogRef.afterClosed().subscribe((result) => {
              if (result === 'refresh table')
                this.fetchUserWishlistReport();
            });
          }
        }
        else {
          let bodyObj = {
            uiState: this.queryParams['state'],
            uiDistrict: this.queryParams['district'],
            pincode: this.queryParams['pincode'] || event.pin,
            wishlistId: String(this.data.wishlist.id),
            memKeysToDelete: [String(event.SL_NO)],
          };
          this._wishlistService.delWishlistItem(bodyObj).subscribe({
            next: (response: any) => {
              this.dialog.open(DpSuccessMessageComponent, {
                panelClass: 'common-pannel-dialog-container',
                data: {
                  mainHeading: 'Data had been deleted successfully',
                  buttonValue: 'Done',
                },
              });
              if (response) {
                deleteRowData(
                  this.printAndMonitorUserWishlists,
                  'SL_NO',
                  event.SL_NO
                );
              }
              this.isLoading = false
            },
            error: (error: string | undefined) => {
              this.toaster.error(error);
              this.isLoading = false
              this.fetchUserWishlistReport();
            },
          });
        }
      }
    }
    else {
      this._wishlistService
        .deleteUserWishlist(
          this.data.id ? this.data.id : this.data.wishlist.id,
          event.id,
          { listType: 'PHL' }
        )
        .subscribe({
          next: (response: any) => {
            this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: 'Data had been deleted successfully',
                buttonValue: 'Done',
              },
            });
            deleteRowData(this.userWishlists, 'id', event.id);
            this.isReload = true;
          },
          error: (error) => {
            this.toaster.error(error);
          },
        });
    }
  }
  onClose() {
    this.wishListUsers = [];
    this.filterUserWishlist = [];
    this.dialogRef.close(this.isReload);
  }
  deleteEntireWishlistDialog() {
    if (this.data.type === 'centralizedPm') {
      this._wishlistService
        .delWishlist({
          wishlistId: String(this.data.wishlist.id),
          uiState: this.queryParams['state'],
          uiDistrict: this.queryParams['district'],
          pincode: this.queryParams['pincode'],
        })
        .subscribe({
          next: (response: any) => {
            if (!response.error)
              this.dialog.open(DpSuccessMessageComponent, {
                panelClass: 'common-pannel-dialog-container',
                data: {
                  mainHeading: `Wishlist ${this.data.name} has been deleted`,
                  subHeading:
                    'You can access all wish-lists from the ‘View wishlist’ menu on the Print and Monitor page ',
                  buttonValue: 'Done',
                },
              });
            this.dialogRef.close(true);
          },
          error: (error) => {
            this.toaster.error(error);
          },
        });
    } else {
      this._wishlistService
        .delPmWishlist(this.data.wishlist.id, {
          uiState: this.queryParams['state'],
          uiDistrict: this.queryParams['district'],
        })
        .subscribe({
          next: (response: any) => {
            this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: 'Data had been deleted successfully',
                buttonValue: 'Done',
              },
            });
            this.dialogRef.close(true);
            // deleteRowData()
          },
          error: (error: string | undefined) => {
            this.toaster.error(error);
            this.dialogRef.close();
          },
        });
    }
  }
  ngOnDestroy(): void {
    this.wishListUsers = [];
    this.filterUserWishlist = [];
  }
}
